import React, { useEffect } from 'react';
import flatten from 'flat';
import { IntlProvider, useIntl } from 'react-intl';
import { useServiceSettings } from 'contexts/serviceSettings';
import { useBoundaryContext } from 'components/ErrorBoundary/ErrorBoundary';

type Props = {
  children: React.ReactNode;
};

// Propagate translations up to the top level
// error boundary as soon as they are available.
const SetBoundaryIntl = () => {
  const setIntl = useBoundaryContext();
  const intl = useIntl();

  useEffect(() => {
    setIntl(intl);
  }, [intl, setIntl]);

  return null;
};

/**
 * Provides internationalization (i18n) support by fetching translations
 * from "Översätta" via the service api. The translations are then used in react
 * via react-i18n.
 *
 * @see https://github.com/formatjs/react-intl/tree/master/docs
 * @see https://formatjs.io/guides/
 */
const I18NProvider = ({ children }: Props) => {
  const { kompisSettings, translations } = useServiceSettings();

  return (
    <IntlProvider locale={kompisSettings.locale} messages={flatten(translations)}>
      <SetBoundaryIntl />
      {children}
    </IntlProvider>
  );
};

export default I18NProvider;
